export default __webpack_public_path__ + "fcc08a9d9462a48b0d649bdced73c24f.png";